import api from "@client/content/lib/api";
import { type ModuleApiInfo } from "@client/content/selectors";
import { type HttpApiResponse } from "@client/types/Api";
import { type CourseProgress } from "./types";

export default {
  init: (
    apiInfo: ModuleApiInfo,
    id: string,
    programModuleIds: string[]
  ): Promise<HttpApiResponse<CourseProgress.Api.InitResponse>> =>
    api.get(apiInfo, `/api/site/v1/modules/courses/${id}/progress`, { programModuleIds })
};
